export const GET_ABSENCES = "GET_ABSENCES";
export const GET_ABSENCES_DATES = "GET_ABSENCES_DATES";
export const GET_ABSENCES_REASONS = "GET_ABSENCES_REASONS";
export const GET_ABSENCE_BY_ID = "GET_ABSENCE_BY_ID";
